import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import axios from "axios";
import {
  GET_DELIVERY_ORDERS_URL,
  GET_REJECT_ORDER_URL,
  ACCEPT_TO_DELIVER_URL,
} from "../../../configs";
import { Spinner, Pane } from "evergreen-ui";
import "react-responsive-modal/src/styles.css";
import { BottomSheet } from "react-spring-bottom-sheet";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import Echo from "laravel-echo";
import { Button } from "antd";

class Footer extends Component {
  state = {
    orders: [],
    in_loader: false,
    open: false,
    reason: "",
  };
  play_notification_alarm() {
    if (window.ReactNativeWebView) {
      const response = {
        type: "play_sound",
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(response));
    }
  }

  componentDidMount() {

    if (window.ReactNativeWebView) {
      const response = {
        type: "location_ping",
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(response));
    }

    window.echo = new Echo({
      broadcaster: "socket.io",
      host: "https://fleet.howincloud.com:6001",
      logToConsole: true,
      transports: ["websocket"],
    });

    // setTimeout(, 60000);

    window.echo
      .channel("fleet_database_" + localStorage.getItem("tenant"))
      .listen(".order-event", (data) => {
        // this.play_notification_alarm()
        // console.log(data.order_data.agent_id,this.props.delivery_user.agent_id)
        if (data.order_data.agent_id == this.props.delivery_user.agent_id) {
          this.callApis(this.props.data_core);
          this.play_notification_alarm();

          // console.log('Order Assigned');
        } else {
          console.log("Order Not assigned To Agent");
        }
      });

    // window.echo.channel('delivery-order-channel-'+this.props.delivery_user.data.id)
    // 	.listen('.OrderEvent', (data) => {
    // 		console.log(data)
    // 	this.setState({new_orders: [...this.state.new_orders, data.order_data]})
    // });

    this.callApis(this.props.data_core);
  }

  componentWillUnmount() {
    window.echo.disconnect();
  }

  componentWillReceiveProps(newProps) {
    this.setState({ orders: [] });
    this.callApis(newProps.data_core);
  }

  onOpenModal = (id) => {
    this.setState({ open: true, reject_id: id });
  };

  onCloseModal() {
    this.setState({ open: false, reject_id: null });
  }

  callApis(data_core) {
    this.setState({ in_loader: true });
    axios
      .post(GET_DELIVERY_ORDERS_URL, {
        data_core: data_core,
        token: this.props.delivery_user.auth_token,
      })
      .then((response) => {
        const orders = response.data;
        if (orders.length > 0) {
          this.setState({ orders: orders });
          const ids = orders.map(order => order.id);

          localStorage.setItem('ordersIds', JSON.stringify(ids));
          this.setState({ in_loader: false });
        } else {
          this.setState({ orders: [] });
          this.setState({ in_loader: false });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  rejectReason = (event) => {
    this.setState({ reason: event.target.value });
  };

  __rejectOrder() {
    this.setState({ open: false, reject_id: null });
    axios
      .post(GET_REJECT_ORDER_URL, {
        order_id: this.state.reject_id,
        token: this.props.delivery_user.auth_token,
        reason: this.state.reason,
      })
      .then((response) => {
        this.callApis(this.props.data_core);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  __acceptToDeliver(order_id) {
    axios
      .post(ACCEPT_TO_DELIVER_URL, {
        order_id: order_id,
        token: this.props.delivery_user.auth_token,
      })
      .then((response) => {
        this.callApis(this.props.data_core);
      })
      .catch(function (error) {
        alert("Somthing Went Wrong !");
      });
  }

  orderTimeOut(e) {
    this.setState({
      orders: this.state.orders.filter(function (order) {
        return order.id !== e;
      }),
    });
  }
  render() {
    return (
      <React.Fragment>
        {this.state.in_loader === true && (
          <Pane
            display='flex'
            alignItems='center'
            justifyContent='center'
            height={500}>
            <Spinner />
          </Pane>
        )}

        {this.props.data_core == "accepted_orders" &&
          localStorage.getItem("qr_functionality") == "1" && (
            <div className='d-flex justify-content-center'>
              <Button
                type='primary'
                style={{
                  borderRadius: "10px",
                  position: "fixed",
                  bottom: "15%",
                  backgroundColor: "#003282",
                  borderColor: "#003282",
                  height: "60px",
                  width: "74%",
                  filter: "drop-shadow(2px 4px 6px #00000052)",
                }}
                loading={this.state.button_loader}
                onClick={() => {
                  this.setState({ button_loader: true });
                  if (window.ReactNativeWebView) {
                    const response = {
                      type: "initiate_qr_scanner",
                      data: {
                        type: "accepted_orders",
                        auth_token: this.props.delivery_user.auth_token,
                        expected_data: null,
                        go_back_to: window.location.href,
                      },
                    };
                    window.ReactNativeWebView.postMessage(
                      JSON.stringify(response)
                    );
                  }
                }}>
                Pickup via QR{" "}
                <img
                  style={{ height: "16px", marginLeft: "12px" }}
                  src='https://i.ibb.co/P9SvQ0P/scanner.png'
                  alt='scanner'
                />
              </Button>
            </div>
          )}

        {this.state.orders.length > 0 ? (
          this.state.orders.map((order, index) => (
            <React.Fragment key={index}>
              <div className='container'>
                {/* <Link delay={200} to={'/order/view/' + order.id}> */}
                <div
                  className='card  mb-10 p-10'
                  style={{
                    background: "#FFFFFF",
                    boxShadow: "0px 1px 6px rgba(0, 42, 127, 0.05)",
                    borderRadius: "18px",
                  }}>
                  <div className='p-10 ' style={{ borderRadius: "10px" }}>
                    <div
                      className=''
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignContent: "center",
                        alignItems: "center",
                      }}>
                      <span
                        className='font-weight-bold font-size-h4'
                        style={{ color: "#1167A3" }}>
                        #{order.client_order_identifier.slice(-9)}
                      </span>
                      <span className='text-muted font-size-sm'>
                        {" "}
                        <Moment format='DD/MM/YYYY hh:mma'>
                          {order.created_at}
                        </Moment>
                      </span>
                    </div>
                    {order.pickup_dimension == "single" && (
                      <div
                        className='mt-2'
                        style={{
                          display: "flex",
                          alignItems: "center",
                          alignContent: "center",
                          justifyContent: "space-between",
                        }}>
                        <span className='text-muted'>
                          {" "}
                          {localStorage.getItem("pickup")} :
                          <span className='font-weight-bold'>
                            {" "}
                            {order.pickup_name}
                          </span>{" "}
                        </span>
                      </div>
                    )}

                    <div
                      className='mt-2'
                      style={{
                        display: "flex",
                        alignItems: "center",
                        alignContent: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                      }}>
                      {order.hideDeliveryCharge != true && (<span className='text-muted'>
                            {" "}
                            {localStorage.getItem("delivery_charge")} :
                            <span className='font-weight-bold'>
                              {localStorage.getItem("currency")}
                              {order.delivery_charge}
                            </span>{" "}
                          </span>) }
                          
                    

                      {localStorage.getItem("show_details_before_del") ==
                        "1" && (
                        <div>
                          <Link
                            delay={200}
                            to={
                              order.pickup_dimension == "single" ||
                              order.order_status_id == 7
                                ? "/order/view/" + order.id
                                : "/pickup/view/" + order.id
                            }>
                            <button className='btn'>
                              {" "}
                              {localStorage.getItem("details")}{" "}
                            </button>
                          </Link>
                        </div>
                      )}
                      {order.extra_bonus > 0 && (
                        <span className='text-muted'>
                          {" "}
                          {localStorage.getItem("tips_surge")} :
                          <span className='font-weight-bold'>
                            {order.extra_bonus}
                          </span>
                        </span>
                      )}
                    </div>
                    {order.pickup_amount > 0 ? (
                      <div
                        className='mt-2'
                        style={{
                          display: "flex",
                          alignItems: "center",
                          alignContent: "center",
                          justifyContent: "space-between",
                        }}>
                        <span className='text-muted'>
                          {" "}
                          Store Payment Amount :
                          <span className='font-weight-bold'>
                            {localStorage.getItem("currency")}
                            {order.pickup_amount}
                          </span>{" "}
                        </span>
                      </div>
                    ) : null}
                    {order.is_any_store == 1 && (
                      <div className='mt-3'>
                        <span className='badge badge-danger'>
                          Any Store Order
                        </span>
                      </div>
                    )}
                    <div className='mt-3 d-flex justify-content-between align-items-center'>
                      {/* {(order.order_status_id == 6 || order.order_status_id == 7) && ( */}

                      {/* )} */}

                      {(order.order_status_id === 3 ||
                        order.order_status_id === 5) &&
                        order.task_timeout_duration > 0 && (
                          <div>
                            <CountdownCircleTimer
                              isPlaying
                              duration={60}
                              initialRemainingTime={order.left_time}
                              size={60}
                              strokeWidth={5}
                              colors={[
                                ["#9ccc65", 0.33],
                                ["#F7B801", 0.33],
                                ["#A30000", 0.33],
                              ]}
                              onComplete={() => this.orderTimeOut(order.id)}>
                              {({ remainingTime }) => remainingTime}
                            </CountdownCircleTimer>
                          </div>
                        )}

                      {order.order_status_id === 6 && (
                        <div>
                          <div
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              marginBottom: "10px",
                            }}>
                            Pickup your task in
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}>
                            <CountdownCircleTimer
                              isPlaying
                              duration={order.total_time}
                              initialRemainingTime={order.left_time}
                              size={60}
                              strokeWidth={5}
                              colors={[
                                ["#9ccc65", 0.33],
                                ["#F7B801", 0.33],
                                ["#A30000", 0.33],
                              ]}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                              // onComplete={() => this.orderTimeOut(order.id)}
                            >
                              {({ remainingTime }) => remainingTime}
                            </CountdownCircleTimer>
                          </div>
                        </div>
                      )}

                      {order.order_status_id === 7 && (
                        <div>
                          <div
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              marginBottom: "10px",
                            }}>
                            Deliver your task in
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}>
                            <CountdownCircleTimer
                              isPlaying
                              duration={order.total_time}
                              initialRemainingTime={order.left_time}
                              size={60}
                              strokeWidth={5}
                              colors={[
                                ["#9ccc65", 0.33],
                                ["#F7B801", 0.33],
                                ["#A30000", 0.33],
                              ]}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                              // onComplete={() => this.orderTimeOut(order.id)}
                            >
                              {({ remainingTime }) => remainingTime}
                            </CountdownCircleTimer>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {(order.order_status_id === 3 ||
                    order.order_status_id === 5) && (
                    <div className='d-flex justify-content-between'>
                      <div
                        style={{ width: "17%" }}
                        onClick={() => this.onOpenModal(order.id)}>
                        <svg
                          width='auto'
                          height='auto'
                          viewBox='0 0 54 52'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <rect width='54' height='52' rx='13' fill='#EC5252' />
                          <path
                            d='M33.0938 18.9062L20.9062 31.0938M20.9062 18.9062L33.0938 31.0938'
                            stroke='white'
                            stroke-width='3'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                          />
                        </svg>
                      </div>

                      <div
                        style={{ width: "83%" }}
                        class='ml-2'
                        onClick={() => this.__acceptToDeliver(order.id)}>
                        <svg
                          width='auto'
                          height='auto'
                          viewBox='0 0 266 52'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <rect
                            width='266'
                            height='52'
                            rx='12'
                            fill='#5ADC7E'
                          />
                          <path
                            d='M113.173 31C113.041 30.568 112.891 30.124 112.723 29.668C112.567 29.212 112.411 28.756 112.255 28.3H107.395C107.239 28.756 107.077 29.212 106.909 29.668C106.753 30.124 106.609 30.568 106.477 31H103.561C104.029 29.656 104.473 28.414 104.893 27.274C105.313 26.134 105.721 25.06 106.117 24.052C106.525 23.044 106.921 22.09 107.305 21.19C107.701 20.278 108.109 19.39 108.529 18.526H111.211C111.619 19.39 112.021 20.278 112.417 21.19C112.813 22.09 113.209 23.044 113.605 24.052C114.013 25.06 114.427 26.134 114.847 27.274C115.267 28.414 115.711 29.656 116.179 31H113.173ZM109.807 21.352C109.747 21.532 109.657 21.778 109.537 22.09C109.417 22.402 109.279 22.762 109.123 23.17C108.967 23.578 108.793 24.028 108.601 24.52C108.421 25.012 108.235 25.528 108.043 26.068H111.589C111.397 25.528 111.211 25.012 111.031 24.52C110.851 24.028 110.677 23.578 110.509 23.17C110.353 22.762 110.215 22.402 110.095 22.09C109.975 21.778 109.879 21.532 109.807 21.352ZM116.97 26.266C116.97 25.582 117.078 24.94 117.294 24.34C117.522 23.728 117.846 23.2 118.266 22.756C118.686 22.3 119.196 21.94 119.796 21.676C120.396 21.412 121.08 21.28 121.848 21.28C122.352 21.28 122.814 21.328 123.234 21.424C123.654 21.508 124.062 21.634 124.458 21.802L123.9 23.944C123.648 23.848 123.372 23.764 123.072 23.692C122.772 23.62 122.436 23.584 122.064 23.584C121.272 23.584 120.678 23.83 120.282 24.322C119.898 24.814 119.706 25.462 119.706 26.266C119.706 27.118 119.886 27.778 120.246 28.246C120.618 28.714 121.26 28.948 122.172 28.948C122.496 28.948 122.844 28.918 123.216 28.858C123.588 28.798 123.93 28.702 124.242 28.57L124.62 30.766C124.308 30.898 123.918 31.012 123.45 31.108C122.982 31.204 122.466 31.252 121.902 31.252C121.038 31.252 120.294 31.126 119.67 30.874C119.046 30.61 118.53 30.256 118.122 29.812C117.726 29.368 117.432 28.846 117.24 28.246C117.06 27.634 116.97 26.974 116.97 26.266ZM125.513 26.266C125.513 25.582 125.621 24.94 125.837 24.34C126.065 23.728 126.389 23.2 126.809 22.756C127.229 22.3 127.739 21.94 128.339 21.676C128.939 21.412 129.623 21.28 130.391 21.28C130.895 21.28 131.357 21.328 131.777 21.424C132.197 21.508 132.605 21.634 133.001 21.802L132.443 23.944C132.191 23.848 131.915 23.764 131.615 23.692C131.315 23.62 130.979 23.584 130.607 23.584C129.815 23.584 129.221 23.83 128.825 24.322C128.441 24.814 128.249 25.462 128.249 26.266C128.249 27.118 128.429 27.778 128.789 28.246C129.161 28.714 129.803 28.948 130.715 28.948C131.039 28.948 131.387 28.918 131.759 28.858C132.131 28.798 132.473 28.702 132.785 28.57L133.163 30.766C132.851 30.898 132.461 31.012 131.993 31.108C131.525 31.204 131.009 31.252 130.445 31.252C129.581 31.252 128.837 31.126 128.213 30.874C127.589 30.61 127.073 30.256 126.665 29.812C126.269 29.368 125.975 28.846 125.783 28.246C125.603 27.634 125.513 26.974 125.513 26.266ZM134.056 26.338C134.056 25.498 134.182 24.766 134.434 24.142C134.698 23.506 135.04 22.978 135.46 22.558C135.88 22.138 136.36 21.82 136.9 21.604C137.452 21.388 138.016 21.28 138.592 21.28C139.936 21.28 140.998 21.694 141.778 22.522C142.558 23.338 142.948 24.544 142.948 26.14C142.948 26.296 142.942 26.47 142.93 26.662C142.918 26.842 142.906 27.004 142.894 27.148H136.81C136.87 27.7 137.128 28.138 137.584 28.462C138.04 28.786 138.652 28.948 139.42 28.948C139.912 28.948 140.392 28.906 140.86 28.822C141.34 28.726 141.73 28.612 142.03 28.48L142.39 30.658C142.246 30.73 142.054 30.802 141.814 30.874C141.574 30.946 141.304 31.006 141.004 31.054C140.716 31.114 140.404 31.162 140.068 31.198C139.732 31.234 139.396 31.252 139.06 31.252C138.208 31.252 137.464 31.126 136.828 30.874C136.204 30.622 135.682 30.28 135.262 29.848C134.854 29.404 134.548 28.882 134.344 28.282C134.152 27.682 134.056 27.034 134.056 26.338ZM140.356 25.312C140.344 25.084 140.302 24.862 140.23 24.646C140.17 24.43 140.068 24.238 139.924 24.07C139.792 23.902 139.618 23.764 139.402 23.656C139.198 23.548 138.94 23.494 138.628 23.494C138.328 23.494 138.07 23.548 137.854 23.656C137.638 23.752 137.458 23.884 137.314 24.052C137.17 24.22 137.056 24.418 136.972 24.646C136.9 24.862 136.846 25.084 136.81 25.312H140.356ZM151.084 26.338C151.084 25.51 150.898 24.85 150.526 24.358C150.154 23.854 149.602 23.602 148.87 23.602C148.63 23.602 148.408 23.614 148.204 23.638C148 23.65 147.832 23.668 147.7 23.692V28.534C147.868 28.642 148.084 28.732 148.348 28.804C148.624 28.876 148.9 28.912 149.176 28.912C150.448 28.912 151.084 28.054 151.084 26.338ZM153.82 26.266C153.82 26.998 153.73 27.664 153.55 28.264C153.37 28.864 153.106 29.38 152.758 29.812C152.41 30.244 151.978 30.58 151.462 30.82C150.946 31.06 150.352 31.18 149.68 31.18C149.308 31.18 148.96 31.144 148.636 31.072C148.312 31 148 30.898 147.7 30.766V34.33H145.018V21.856C145.258 21.784 145.534 21.718 145.846 21.658C146.158 21.586 146.482 21.526 146.818 21.478C147.166 21.43 147.514 21.394 147.862 21.37C148.222 21.334 148.564 21.316 148.888 21.316C149.668 21.316 150.364 21.436 150.976 21.676C151.588 21.904 152.104 22.234 152.524 22.666C152.944 23.086 153.262 23.602 153.478 24.214C153.706 24.826 153.82 25.51 153.82 26.266ZM155.791 19.174L158.473 18.742V21.532H161.695V23.764H158.473V27.094C158.473 27.658 158.569 28.108 158.761 28.444C158.965 28.78 159.367 28.948 159.967 28.948C160.255 28.948 160.549 28.924 160.849 28.876C161.161 28.816 161.443 28.738 161.695 28.642L162.073 30.73C161.749 30.862 161.389 30.976 160.993 31.072C160.597 31.168 160.111 31.216 159.535 31.216C158.803 31.216 158.197 31.12 157.717 30.928C157.237 30.724 156.853 30.448 156.565 30.1C156.277 29.74 156.073 29.308 155.953 28.804C155.845 28.3 155.791 27.742 155.791 27.13V19.174Z'
                            fill='white'
                          />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </React.Fragment>
          ))
        ) : (
          <React.Fragment>
            {this.props.job_status ? (
              <div
                className='d-flex justify-content-center align-items-center'
                style={{ height: "75vh" }}>
                <div>
                  <Player
                    autoplay
                    loop
                    src='https://assets3.lottiefiles.com/packages/lf20_e2afpo0b.json'
                    style={{ height: "150px", width: "150px" }}>
                    <Controls
                      visible={false}
                      buttons={["play", "repeat", "frame", "debug"]}
                    />
                  </Player>
                  <div className='text-muted text-center'>
                    {localStorage.getItem("searching_nearby_tasks")}
                  </div>
                </div>
              </div>
            ) : (
              <div
                className='d-flex justify-content-center align-items-center'
                style={{ height: "75vh" }}>
                <div>
                  <Player
                    autoplay
                    loop
                    src='https://assets9.lottiefiles.com/packages/lf20_80addab9.json'
                    style={{ height: "150px", width: "150px" }}>
                    <Controls
                      visible={false}
                      buttons={["play", "repeat", "frame", "debug"]}
                    />
                  </Player>
                  <div className='text-muted text-center'>
                    {localStorage.getItem("you_are_off_duty")}
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        )}

        <BottomSheet
          open={this.state.open}
          snapPoints={({ maxHeight }) => 0.7 * maxHeight}
          header={
            <div
              className='font-weight-bold text-black'
              style={{ fontSize: "initial" }}>
              {localStorage.getItem("do_u_want_reject_order")}
            </div>
          }
          onDismiss={() => this.onCloseModal()}>
          <div className='container'>
            <div className='form-group'>
              <label className='col-form-label text-dark'>
                {localStorage.getItem("reason")}
              </label>
              <input
                className='form-control'
                name='reason'
                onChange={this.rejectReason}
                required
                type='text'
                style={{ border: "1px solid black" }}
                placeholder={localStorage.getItem("enter_reason_reject_order")}
              />

              <label className='col-form-label text-danger'>
                There will be deductions from your wallet for this action,
                Please mark out of duty if you are not wanting to take orders.
              </label>
            </div>
            <div className='text-center'>
              <button
                className='btn btn-danger'
                onClick={() => this.__rejectOrder()}
                type='submit'>
                {localStorage.getItem("yes")}
              </button>
              <button
                className='btn btn-success ml-3'
                onClick={() => this.onCloseModal()}
                type='button'>
                {localStorage.getItem("no")}
              </button>
            </div>
          </div>
        </BottomSheet>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  delivery_user: state.delivery_user.delivery_user.data,
});

export default connect(mapStateToProps)(Footer);
